import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import WideTile from "../components/Views/WideTile";
import { getTests } from "../api";

export default function Tests() {
  const nav = useNavigate();

  const testQuery = useQuery({
    queryKey: ["tests"],
    queryFn: getTests,
  });

  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <Header />
      <div className="works-container">
        {testQuery.data
          ?.filter((workData: any) => workData.is_open)
          .map((workData: any) => (
            <WideTile
              key={workData.id}
              url={workData.images[0]?.url}
              name={workData.name}
              description={workData.description}
              onClick={() => nav(`/tests/${workData.url_to}`)}
            />
          ))}
      </div>
    </div>
  );
}
